export const GUEST_MODE_KEY = "bijen_app_guest_mode";

export const GUEST_FEATURES = Object.freeze({
  localData: true,
  camera: true,
  location: true,
  inspections: true,
  planning: true,
  cloudSync: false,
  multiDevice: false,
  teams: false,
  export: false,
  accountDeletion: false,
  aiSuggestions: false,
  queenBreeding: false,
});

export const ACCOUNT_FEATURES = Object.freeze(
  Object.fromEntries(Object.keys(GUEST_FEATURES).map((key) => [key, true])),
);

export function guestModeStored() {
  return typeof window !== "undefined" && localStorage.getItem(GUEST_MODE_KEY) === "1";
}

export function featuresForSession(isGuest) {
  return isGuest ? GUEST_FEATURES : ACCOUNT_FEATURES;
}
